module.exports = __webpack_public_path__ + "static/media/Header 2.6fe8deee.svg";